import * as _ from "lodash";
import * as $ from "jquery";
import * as moment from "moment-timezone";
import {BaseList, TableProperties} from "../../_BaseList";
import {DashboardCollection} from "../../../collections/Dashboards";
import {DashboardOverviewView} from "./DashboardOverviewView";
import {ModifyDashboardModal} from "../../modals/dashboard/ModifyDashboardModal";
import {DashboardWidgetCollection} from "../../../collections/DashboardWidgets";
import {BaseAccountListView, BaseAccountViewOptions} from "../_BaseAccountViews";
import {Intercom} from "../../../common/intercom";
import {GenericDeleteModal} from "../../modals/GenericDeleteModal";


export class DashboardAccountView extends BaseAccountListView {

    private dashboardCollection: DashboardCollection = null;
    private dashboardWidgetCollections: { [dashboardId: number]: DashboardWidgetCollection } = {};

    constructor(options: BaseAccountViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'click .add-dashboard': 'handleAddDashboardClick',
                'click .delete-from-list': 'deleteDashboard',
            }
        }));
    }

    show(orgId, dashboardId?, detail?, subDetail?) {
        var deferreds = [];
        if (this.options.permissionCollection.canViewOrganization(this.options.currentOrganizationId)) {
            var dashboards = this.options.dashboardCollection.filter((dashboard) => {
                return dashboard.get('organization_id') === this.options.currentOrganizationId;
            });

            this.dashboardCollection = new DashboardCollection(dashboards);

            if (!dashboardId) {
                this.dashboardCollection.each((dash) => {
                    this.dashboardWidgetCollections[dash.get('id')] = new DashboardWidgetCollection([], {dashboardId: dash.get('id')});
                    deferreds.push(this.dashboardWidgetCollections[dash.get('id')].fetch());
                });
            }
        }

        $.when.apply($, deferreds).then(() => {
            if (dashboardId) {
                var view = new DashboardOverviewView(_.extend({}, this.options, {
                    dashboardCollection: this.dashboardCollection
                }));

                this.$el.empty().append(view.render().$el);
                view.show(dashboardId, detail, subDetail);
                this.subViews.push(view);
                return;
            }

            this.collectionLoaded = true;
            this.render();
            (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        });
    }

    render() {
        this.$el.html(this.template({
            organizationCollection: this.options.organizationCollection,
            permissionCollection: this.options.permissionCollection,
            currentOrganizationId: this.options.currentOrganizationId,
            collectionLoaded: this.collectionLoaded,
            urlAddon: '/dashboards'
        }));

        var canAddDashboard = this.options.permissionCollection.canCreateNewDashboard(this.options.currentOrganizationId);
        this.$('.container').append(this.panelTemplate({
            panelTitle: {text: 'Dashboards', url: null},
            panelClass: 'dashboards',
            panelWidth: '',
            headerLink: null,
            addButton: {canAdd: canAddDashboard, label: "Add Dashboard", 'class': "add-dashboard"},
            search: true,
            collectionLoaded: this.collectionLoaded,
            footer: null
        }));

        this.showBreadcrumbs();
        if (this.collectionLoaded) this.showTable();
        this.delegateEvents();
        return this;
    }

    showTable() {
        var getDashboardModifiedDate = function (dash, widCols) {
            var dates = [moment(dash.get('modified')).format("L")];
            var widgetDate = 0;
            widCols[dash.get('id')].each((widget) => {
                if (widget.get('modified') > widgetDate) widgetDate = widget.get('modified')
            });

            if (widgetDate !== 0) dates.push(moment.unix(widgetDate).format("L"));

            dates = _.sortBy(dates, (date) => {
                return date;
            }).reverse();
            return _.first(dates);
        };

        var dashboardTable = new BaseList(this.options);
        var dashboardTableProperties: TableProperties = {
            canDeletePermissionFunction: this.options.permissionCollection.canDeleteDashboard.bind(this.options.permissionCollection),
            canDeletePermissionFunctionAttribute: 'id',
            rowUrl: '#/account/' + this.options.currentOrganizationId + '/dashboards/',
            tableEmptyText: 'There are no Dashboards',
            columnProperties: {
                'Dashboard Name': {
                    attribute: 'name',
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '12'
                    }
                },
                'Installs': {
                    customColumn: {
                        templateFunction: _.template(
                            '<% var filteredChannels = dashboardChannelCollection.filter(function(c){ return c.get("dashboard_channel_dashboard_id") === mod.get("id")}); %>' +
                            '<% var dbInstallNames = _.map(' +
                            '_.uniq(' +
                            '_.map(filteredChannels, function(c){' +
                            'return c.get("install_id")' +
                            '})), function(installId){' +
                            'if(permissionCollection.canViewInstall(installId)){' +
                            'return _.find(installCollection.models, function(i){return i.get("id") === installId}).getDisplayName()' +
                            '}' +
                            '}); %>' +
                            ' <div class="col-md-3 col-sm-3 col-xs-10" data-table-cell=<%- _.compact(dbInstallNames).sort().join(", ") %>>' +

                            '<%- _.compact(dbInstallNames).sort().join(", ") %>' +
                            ' </div>'),
                        variables: {
                            dashboardChannelCollection: this.options.dashboardChannelCollection,
                            permissionCollection: this.options.permissionCollection,
                            installCollection: this.options.installCollection
                        }
                    },
                    columnSizes: {
                        'sm': '3',
                        'md': '3',
                        'xs': '10'
                    }
                },
                'Created': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('<% var inviteDate = mod.get("created") ? mod.get("created") : null %> ' +
                            ' <% if(inviteDate){ %> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center" data-table-cell=<%- moment(inviteDate).format("L") %> ><%- moment(inviteDate).format("L") %></div>' +
                            ' <% }else{ %>' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center" data-table-cell="">' +
                            ' ' +
                            ' </div>' +
                            ' <% } %>'),
                        variables: {
                            moment: moment
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
                'Modified': {
                    centerColumn: true,
                    customColumn: {
                        templateFunction: _.template('' +
                            '<% var inviteDate = getDashboardModifiedDate(mod, widCols) %> ' +
                            ' <div class="col-md-2 col-sm-2 col-xs-10 text-center"><%- inviteDate ? inviteDate : "" %></div>'
                        ),
                        variables: {
                            moment: moment,
                            widCols: this.dashboardWidgetCollections,
                            getDashboardModifiedDate: getDashboardModifiedDate
                        }
                    },
                    columnSizes: {
                        'sm': '2',
                        'md': '2',
                        'xs': '10'
                    }
                },
            }
        };

        this.$('.dashboards .panel-body > .row').append(dashboardTable.renderCollectionList(this.dashboardCollection, dashboardTableProperties).$el);
    }

    showBreadcrumbs() {
        super.showBreadcrumbs('Dashboards', 'Categories');
    }

    handleAddDashboardClick() {
        var view = new ModifyDashboardModal(_.extend({}, this.options, {
            modelId: null,
        }));
        $('.modals').append(view.render().el);
        view.show();
    }

    deleteDashboard(e) {
        e.stopPropagation();
        var id = Number($(e.currentTarget).attr('data-model-id'));

        var dasboard = this.options.dashboardCollection.findWhere({id: id});

        var modal = new GenericDeleteModal({
            type: 'Dashboard',
            name: dasboard.get('name'),
            func: () => {
                return $.ajax({
                    type: "DELETE",
                    url: this.options.dashboardCollection.url() + '/' + id,
                    dataType: 'json',
                    contentType: "application/json; charset=utf-8",
                    complete: () => {
                        Intercom.trackEvent('deleted-install-from-org', {
                            org_id: this.options.currentOrganizationId,
                            user_id: id
                        });

                        $.when(this.options.dashboardCollection.getCollectionFetchPromise()).done(() => {
                            this.reloadUrl();
                        })
                    }
                });
            }
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/dashboards/DashboardAccountView.ts